<template>
  <span :class="DS_FIELDSET_CLASSES.Actions">
    <slot />
    <DSButton
      v-if="props.removable"
      :variant="DS_BUTTON_VARIANT.Ghost"
      :size="DS_SIZE.Small"
      prefix-icon="trash"
      :disabled="props.disabled"
      aria-label="Remove fieldset"
      data-cy="ds-fieldset__remove-button"
      @click="emit('remove')"
    />
  </span>
</template>

<script setup lang="ts">
import DSButton from "@/src/design_system/button_and_controls/button/components/DSButton.vue";
import { DS_BUTTON_VARIANT } from "@/src/design_system/button_and_controls/button/types/props";
import { DS_FIELDSET_CLASSES } from "@/src/design_system/form_elements/fieldset/constants/classes";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

const props = withDefaults(
  defineProps<{
    removable?: boolean;
    disabled?: boolean;
  }>(),
  {
    removable: false,
    disabled: false,
  }
);

const emit = defineEmits<{
  (e: "remove"): void;
}>();
</script>
